const  workspaceItems = [
  {
    "name": "Dartmouth Daily Standup",
    "logo": null,
    "key": "UT",
    "managers": [],
    "assignees": [
      "usr-cda499047b",
      "usr-0ef6bcedcd"
    ],
    "groups": [],
    "leads": [],
    "workspaceId": "wos-2bf731d47d",
    "customer": "cus-eeca3a713f",
    "description": "Dartmouth Daily Standup Dartmouth Daily StandupDartmouth Daily Standup",
    "createdBy": "usr-cda499047b",
    "createdAt": "2024-07-11T06:24:13.979Z",
    "updatedBy": "usr-cda499047b",
    "updatedAt": "2024-07-29T13:29:32.438Z"
  },
  {
    "name": "Dartmouth Daily Standup",
    "logo": null,
    "key": "GCP",
    "managers": [],
    "assignees": [
      "usr-0ef6bcedcd",
      "usr-cda499047b",
      "usr-92ffb9aac2"
    ],
    "groups": [],
    "leads": [],
    "workspaceId": "wos-468f89aa9c",
    "customer": "cus-51ceee13af",
    "description": "Dartmouth Daily Standup Dartmouth Daily StandupDartmouth Daily Standup",
    "createdBy": "usr-cda499047b",
    "createdAt": "2024-07-12T09:35:38.553Z",
    "updatedBy": "usr-cda499047b",
    "updatedAt": "2024-08-08T18:34:59.572Z"
  },
  {
    "name": "Dartmouth Daily Standup",
    "logo": null,
    "key": "QN",
    "managers": [
      "usr-cda499047b"
    ],
    "assignees": [
      "usr-0ef6bcedcd",
      "usr-8612f12a6d",
      "usr-390a642cef",
      "usr-cda499047b",
      "usr-92ffb9aac2",
      "usr-f7cb9dea97"
    ],
    "groups": [
      "grp-7977bfb250",
      "grp-101dd960bb",
      "grp-1b7f92ed3c"
    ],
    "leads": [
      "usr-cda499047b"
    ],
    "workspaceId": "wos-925b2bc4be",
    "customer": "cus-eeca3a713f",
    "description": "Dartmouth Daily Standup Dartmouth Daily StandupDartmouth Daily Standup",
    "createdBy": "usr-cda499047b",
    "createdAt": "2024-07-22T06:27:46.111Z",
    "updatedBy": "usr-92ffb9aac2",
    "updatedAt": "2024-08-16T08:58:23.749Z"
  }
];


const COLUMN = [
  {
    name: "name",
    id: "name",
    label: "Name",
    widget: "text",
    fixed:'left',
    width:100
  },
  {
    name: "email",
    id: "email",
    label: "email",
    widget: "text",
    width:100
  },
  {
    name: "date",
    id: "date",
    label: "Date",
    width:100,
    widget: "date",
    format : "DD-MMM-YYYY"
  },
  {
    name: "slot",
    id: "slot",
    label: "Slot",
    width:100,
    widget: "eventSlot"
  },
  {
    name: "client",
    id: "client",
    label: "TimeZone",
    width:100,
    widget: "text"
  },
  {
    name: "status",
    id: "status",
    width:80,
    label: "Status",
    widget: "invoicestatus",
    fixed:'right'
  }
];

const EVENT_WORKFLOW = [
  {
    label: "Planning",
    name: "Planning",
    value: 1,
    color: "#65789B",
    background: "rgba(101, 120, 155, 0.1)",
    nextStatuses: [
      { label: "Approval", name: "Approval", value: 2 }
    ]
  },
  {
    label: "Approval",
    name: "Approval",
    value: 2,
    color: "#61DDAA",
    background: "rgba(97, 221, 170, 0.1)",
    nextStatuses: [
      { label: "Approved", name: "Approved", value: 3 },
      { label: "Rejected", name: "Rejected", value: 4 }
    ]
  },
  {
    label: "Approved",
    name: "Approved",
    value: 3,
    color: "#00B8D9",
    background: "rgba(0, 184, 217, 0.1)",
    nextStatuses: [
      { label: "Ongoing", name: "Ongoing", value: 5 }
    ]
  },
  {
    label: "Rejected",
    name: "Rejected",
    value: 4,
    color: "#F5222D",
    background: "rgba(245, 34, 45, 0.1)",
    nextStatuses: [
      { label: "Planning", name: "Planning", value: 1 }
    ]
  },
  {
    label: "Ongoing",
    name: "Ongoing",
    value: 5,
    color: "#6DC8EC",
    background: "rgba(109, 200, 236, 0.1)",
    nextStatuses: [
      { label: "Feedback", name: "Feedback", value: 6 },
      { label: "Cancelled", name: "Cancelled", value: 7 }
    ]
  },
  {
    label: "Feedback",
    name: "Feedback",
    value: 6,
    color: "#B37FEB",
    background: "rgba(179, 127, 235, 0.1)",
    nextStatuses: [
      { label: "Closed", name: "Closed", value: 8 }
    ]
  },
  {
    label: "Cancelled",
    name: "Cancelled",
    value: 7,
    color: "#FAAD14",
    background: "rgba(250, 173, 20, 0.1)",
    nextStatuses: [
      { label: "Planning", name: "Planning", value: 1 }
    ]
  },
  {
    label: "Closed",
    name: "Closed",
    value: 8,
    color: "#C2C8D5",
    background: "rgba(194, 200, 213, 0.1)",
    nextStatuses: [{ label: "Planning", name: "Planning", value: 1 }]
  }
];

const EVENT_PLANNING_TYPES = [
  {
    label: "Webinar",
    value: 1,
    key: 1,
    icon: "QueryFilled",
    color: "#8DAA5B",
    background: "rgba(141, 170, 91, 0.1)"
  },
  {
    label: "Concert",
    value: 2,
    key: 2,
    icon: "FeatureRequestFilled",
    color: "#4C4C87",
    background: "rgba(76, 76, 135, 0.1)"
  },
  {
    label: "Meetup",
    value: 3,
    key: 3,
    icon: "ImprovementsFilled",
    color: "#F26430",
    background: "rgba(242, 100, 48, 0.1)"
  },
  {
    label: "Training",
    value: 4,
    key: 4,
    icon: "SupportFilled",
    color: "#5A9BD4",
    background: "rgba(90, 155, 212, 0.1)"
  },
  {
    label: "Interview",
    value: 5,
    key: 5,
    icon: "TaskFilled",
    color: "#C96F6F",
    background: "rgba(201, 111, 111, 0.1)"
  },
  {
    label: "Workshop",
    value: 6,
    key: 6,
    icon: "ImprovementsFilled",
    color: "#A678D1",
    background: "rgba(166, 120, 209, 0.1)"
  },
  {
    label: "Seminar",
    value: 7,
    key: 7,
    icon: "TaskFilled",
    color: "#E6A157",
    background: "rgba(230, 161, 87, 0.1)"
  },
  {
    label: "Discussion",
    value: 8,
    key: 8,
    icon: "SupportFilled",
    color: "#3F7C85",
    background: "rgba(63, 124, 133, 0.1)"
  },
  {
    label: "Hackathon",
    value: 9,
    key: 9,
    icon: "TaskFilled",
    color: "#7E5F9E",
    background: "rgba(126, 95, 158, 0.1)"
  },
  {
    label: "Pitch",
    value: 10,
    key: 10,
    icon: "TaskFilled",
    color: "#D75A4A",
    background: "rgba(215, 90, 74, 0.1)"
  },
  {
    label: "Roundtable",
    value: 11,
    key: 11,
    icon: "SupportFilled",
    color: "#5C8D89",
    background: "rgba(92, 141, 137, 0.1)"
  },
  {
    label: "Confurence",
    value: 12,
    key: 12,
    icon: "SupportFilled",
    color: "#BC804E",
    background: "rgba(188, 128, 78, 0.1)"
  }
];



export {
  COLUMN,workspaceItems,
  EVENT_WORKFLOW,
  EVENT_PLANNING_TYPES
};